/* FEEDBACK-6 C11: product card video inset. Loads the video only when the card is near the viewport,
   plays while visible, pauses when it scrolls away. Works for cards injected later (filters, recommendations). */
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
let observer;

const onIntersect = (entries) => {
  entries.forEach(({target, isIntersecting}) => {
    const video = target.querySelector('video');
    if (!video) return;
    if (isIntersecting) {
      if (!video.src && video.dataset.src) {
        if (video.dataset.poster) video.poster = video.dataset.poster;
        video.muted = true;
        video.src = video.dataset.src;
        video.addEventListener('loadeddata', () => target.classList.add('is-ready'), {once: true});
      }
      if (reduceMotion.matches) { video.preload = 'metadata'; return; }
      video.play()?.catch(() => {});
    } else if (!video.paused) {
      video.pause();
    }
  });
};

class PmdCardVideo extends HTMLElement {
  connectedCallback() {
    if (!('IntersectionObserver' in window)) return;
    observer ||= new IntersectionObserver(onIntersect, {rootMargin: '150px 0px', threshold: 0.01});
    observer.observe(this);
  }

  disconnectedCallback() { observer?.unobserve(this); }
}

if (!customElements.get('pmd-card-video')) customElements.define('pmd-card-video', PmdCardVideo);
